<template>
  <ResponsiveLayout
    sticky-actions
    :progress="progress"
    :show-lang-picker="false"
  >
    <template #header_start>
      <ButtonBack @click="emit('back')" />
    </template>
    <template #header_middle>
      <div class="kds-typography-title-medium">
        {{ $t('b2b_self_test_generic_assessment') }}
      </div>
    </template>
    <div class="kds-main-wrapper">
      <h3
        class="kds-typography-title-xlarge"
        v-html="$t('b2b_self_test_confidence_question')"
      />
      <ScoreSlider
        :label="getScoreSliderLabel"
        :max-score="10"
        :max-text="$t('b2b_self_test_confidence_slider_max_hint')"
        :min-text="$t('b2b_self_test_confidence_slider_min_hint')"
        :score="getScoreSliderValue"
        data-qa="score-slider"
        type="green"
        @change="handleSliderChange"
        @tap="handleSliderChange"
      />
    </div>
    <template #actions>
      <BaseButton
        :disabled="!isValid"
        :text="$t('generic_action_continue')"
        data-qa="submit"
        @click="handleNextEvent"
      />
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import useSelfTestReevaluationStore from '@shared/modules/assessment/stores/useSelfTestReevaluationStore.js'
import BaseButton from '@shared/components/BaseButton.vue'
import ScoreSlider from '@shared/components/ScoreSlider.vue'
import { computed } from 'vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import ButtonBack from '@shared/components/ButtonBack.vue'

const reevaluationsStore = useSelfTestReevaluationStore()

defineProps({
  progress: {
    type: Number,
    default: null,
  },
  handleNextEvent: {
    type: Function,
    default: () => {},
  },
})

const emit = defineEmits(['back'])

const confidence = computed(() => reevaluationsStore.confidence)

const isValid = computed(() => confidence.value >= 0 && confidence.value <= 10)

const getScoreSliderValue = computed(() =>
  confidence.value === -1 ? 5 : confidence.value,
)

const getScoreSliderLabel = computed(() =>
  confidence.value === -1 ? '' : `${confidence.value}`,
)

const handleSliderChange = ({ value }) => {
  reevaluationsStore.confidence = value
}
</script>
